import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Body2 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { columnsMapByType } from "~/components/ListView/common";
import { ListItem } from "~/components/ListView/ListItem";
import { useMyTasksColumnsContext } from "~/components/MyWork/MyTasks/context";

const TeamWorkListHeader = ({ hasScrollbar }) => {
  const { t } = useTranslation();
  const { columns = [] } = useMyTasksColumnsContext();

  const renderColumns = useMemo(() => {
    return columns
      .filter((col) => col.active)
      .map((col) => {
        return (
          <Body2
            weight="bold"
            className={`tw-hidden lg:tw-flex col col-${col.name.toLowerCase()} tw-pr-2 tw-justify-end`}
            key={`${col.name.toLowerCase()}-${col.name}`}
          >
            {columnsMapByType[col.name]}
          </Body2>
        );
      });
  }, [columns]);

  return (
    <ListItem className="tw-justify-between columns-header">
      <Body2
        className="tw-p-2 tw-ml-6 col-name tw-flex tw-flex-1"
        weight="bold"
      >
        {t("Name")}
      </Body2>
      {renderColumns}
      <div
        className={classNames("tw-w-9", { "tw-mr-[15px]": hasScrollbar })}
        data-testid="header-settings-gap-column"
      />
    </ListItem>
  );
};

TeamWorkListHeader.propTypes = {
  hasScrollbar: PropTypes.bool,
};

export default TeamWorkListHeader;
